var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blue-container guide-container"},[_c('div',{staticClass:"invitate-box"},[_c('van-image',{attrs:{"width":"100%","fit":"contain","src":_vm.inviteFlowChart}}),_c('GoldTitle',{attrs:{"context":"icon11yaoqingfangshi","extraClass":"invite"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }